module.exports = __webpack_public_path__ + "img/no_image.02d923c1.png";